const Menuitems = [
  {
    id: 1,
    title: "Home",
    href: "/",
  },
  {
    id: 2,
    title: "운영자관리",
    href: "/admin",
  },
  {
    id: 3,
    title: "앱 정보 관리",
    href: "/app",
  },
  {
    id: 4,
    title: "푸시 발송",
    href: "/push",
  },
  {
    id: 5,
    title: "발송 관리",
    href: "/send",
  },
  {
    id: 6,
    title: "템플릿/발송자 관리",
    href: "/templete",
  },
  // {
  //   id: 7,
  //   title: "앱버전 관리",
  //   href: "/pages/Version",
  // },
];

export default Menuitems;